var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"square"},[_c('span',{staticClass:"square__title"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._t("squareInfo")],2)}
var staticRenderFns = []

export { render, staticRenderFns }